module.exports = __webpack_public_path__ + "img/pic_18.4fdbab85.jpg";